import Vue from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import animate from "animate.css";
import VueTouch from 'vue-touch'
import $scroll from "@utils/loading";
import VueCookies from 'vue-cookies'

import { isWeixin } from "@utils";
import "@assets/js/media_750";
import "@assets/css/base.css";
import "@assets/css/reset.css";

// import VConsole from 'vconsole'
// const vConsole = new VConsole()
// Vue.use(vConsole)

Vue.use(animate);
Vue.use(VueCookies)
Vue.use(VueTouch, {name: 'v-touch'})

Vue.config.productionTip = false;
Vue.config.devtools = process.env.NODE_ENV !== "production";
Vue.prototype.$scroll = $scroll;



const _isWechat = isWeixin();
if (_isWechat) {
  const module = () => import("@libs/wechat");
  module().then(Module => {
    Module.default().then(() => Module.oAuth());
  });
}

const $vm = new Vue({
  router,
  store,
  render: h => h(App)
});

setTimeout(() => {
  $vm.$mount("#app");
}, 300);
